import { Appointment } from '../models/appointment.model';
import { UpdatedApproverAssignment } from '../models/approver-assignment.model';
import { UpdatedCallingTreeAssignments } from '../models/calling-tree-assignments.model';
import { Dependent } from '../models/dependent.model';
import {
	EmergencyInfo,
	EmergencyInfoResponse,
} from '../models/emergency-info.model';
import { Housing } from '../models/housing.model';
import { Insurance } from '../models/insurance.model';
import { Pet } from '../models/pet.model';
import { Residency } from '../models/residency.model';
import { UserBasics } from '../models/user-basics.model';
import { UserPassport } from '../models/user-passport.model';
import { UserPhoneInfo } from '../models/user-phone-info.model';
import { UserQatarInfo } from '../models/user-qatar-info.model';
import { UserSearch } from '../models/user-search.model';
import { User } from '../models/user.model';

export class GetUser {
	static readonly type = '[User] GetUser';
	constructor(public userId: number) {}
}

export class ClearUser {
	static readonly type = '[User] ClearUser';
}

export class SetUser {
	static readonly type = '[User] SetUser';
	constructor(public user: User) {}
}

export class ArchiveUser {
	static readonly type = '[User] ArchiveUser';
	constructor(public userId: number) {}
}

export class ActivateUser {
	static readonly type = '[User] ActivateUser';
	constructor(public userId: number) {}
}

export class GetApproverAssignments {
	static readonly type = '[User] GetApproverAssignments';
}

export class UpdateApproverAssignments {
	static readonly type = '[User] UpdateApproverAssignments';
	constructor(public assignments: UpdatedApproverAssignment[]) {}
}

export class GetCallingTreeAssignments {
	static readonly type = '[User] GetCallingTreeAssignments';
}

export class UpdateCallingTreeAssignments {
	static readonly type = '[User] UpdateCallingTreeAssignments';
	constructor(public assignments: UpdatedCallingTreeAssignments) {}
}

export class GetCurrentAppointment {
	static readonly type = '[User] GetCurrentAppointment';
	constructor(public userId: number) {}
}

export class SetCurrentAppointment {
	static readonly type = '[User] SetCurrentAppointment';
	constructor(public appointment: Appointment) {}
}

export class GetManagerDropDowns {
	static readonly type = '[User] GetManagerDropDowns';
}

export class SaveUserGeneralInfo {
	static readonly type = '[User] SaveUserGeneralInfo';
	constructor(
		public user: User,
		public appointment: Appointment,
		public passports: UserPassport[],
		public phoneNumbers: UserPhoneInfo[]
	) {}
}

export class GetUserPassports {
	static readonly type = '[User] GetUserPassports';
	constructor(public userId: number) {}
}

export class GetUserPhones {
	static readonly type = '[User] GetUserPhones';
	constructor(public userId: number) {}
}

export class GetUserHousing {
	static readonly type = '[User] GetUserHousing';
	constructor(public userId: number) {}
}

export class GetAvailableHousingUnits {
	static readonly type = '[User] GetAvailableHousingUnits';
	constructor(public userId: number) {}
}

export class SaveUserHousingInfo {
	static readonly type = '[User] SaveUserHousingInfo';
	constructor(
		public userId: number,
		public housing: Housing
	) {}
}

export class GetUserDependents {
	static readonly type = '[User] GetUserDependents';
	constructor(public userId: number) {}
}

export class SaveUserDependents {
	static readonly type = '[User] SaveUserDependents';
	constructor(
		public userId: number,
		public dependents: Dependent[]
	) {}
}

export class GetMyUser {
	static readonly type = '[User] GetMyUser';
}

export class ConfirmMyRecord {
	static readonly type = '[User] ConfirmMyRecord';
}

export class GetMyAppointments {
	static readonly type = '[User] GetMyAppointments';
}

export class SetUserAppointments {
	static readonly type = '[User] SetUserAppointments';
	constructor(public appointments: Appointment[]) {}
}

export class GetMyResidency {
	static readonly type = '[User] GetMyResidency';
}

export class SetUserResidency {
	static readonly type = '[User] SetUserResidency';
	constructor(public residency: Residency) {}
}

export class GetMyHousing {
	static readonly type = '[User] GetMyHousing';
}

export class GetMyPets {
	static readonly type = '[User] GetMyPets';
}

export class SetUserPets {
	static readonly type = '[User] SetUserPets';
	constructor(public pets: Pet[]) {}
}

export class SaveUserQatarInfo {
	static readonly type = '[User] SaveUserQatarInfo';
	constructor(public userQatarInfo: UserQatarInfo) {}
}

export class GetMyEmergencyInfo {
	static readonly type = '[User] GetMyEmergencyInfo';
}

export class SetUserEmergencyInfo {
	static readonly type = '[User] SetUserEmergencyInfo';
	constructor(public response: EmergencyInfoResponse) {}
}

export class SaveUserEmergencyInfo {
	static readonly type = '[User] SaveUserEmergencyInfo';
	constructor(public emergencyInfo: EmergencyInfo) {}
}

export class GetPersonnel {
	static readonly type = '[User] GetPersonnel';
}

export class GetUserAppointments {
	static readonly type = '[User] GetUserAppointments';
	constructor(public userId: number) {}
}

export class GetUserResidency {
	static readonly type = '[User] GetUserResidency';
	constructor(public userId: number) {}
}

export class GetUserPets {
	static readonly type = '[User] GetUserPets';
	constructor(public userId: number) {}
}

export class GetUserInsurance {
	static readonly type = '[User] GetUserInsurance';
	constructor(public userId: number) {}
}

export class GetUserEmergencyInfo {
	static readonly type = '[User] GetUserEmergencyInfo';
	constructor(public userId: number) {}
}

export class SearchUsers {
	static readonly type = '[User] SearchUsers';
	constructor(public options: UserSearch) {}
}

export class ClearUserSearchResult {
	static readonly type = '[User] ClearUserSearchResult';
}

export class GetInsuranceTypes {
	static readonly type = '[User] GetInsuranceTypes';
}

export class GetEmergencyAreas {
	static readonly type = '[User] GetEmergencyAreas';
}

export class SaveUserBasics {
	static readonly type = '[User] SaveUserBasics';
	constructor(public userBasics: UserBasics) {}
}

export class SaveUserAppointments {
	static readonly type = '[User] SaveUserAppointments';
	constructor(
		public userId: number,
		public appointments: Appointment[]
	) {}
}

export class SaveUserInsurance {
	static readonly type = '[User] SaveUserInsurance';
	constructor(
		public userId: number,
		public insurance: Insurance
	) {}
}
